import React from "react";
import { Stack, Typography } from "@mui/material";

export default function SectionHeader({ eyebrow, title, description }) {
  return (
    <Stack spacing={1} sx={{ mb: 3 }}>
      {eyebrow ? (
        <Typography variant="overline" sx={{ color: "#64748b", letterSpacing: 1.1 }}>
          {eyebrow}
        </Typography>
      ) : null}
      <Typography variant="h5" sx={{ color: "#0f172a", fontWeight: 600 }}>
        {title}
      </Typography>
      {description ? <Typography sx={{ color: "#64748b" }}>{description}</Typography> : null}
    </Stack>
  );
}